export default __webpack_public_path__ + "static/media/sponsor-3.46e7e1cd.svg";